import { toast } from '@sales-center/components'
import { FileRejection } from 'react-dropzone'
import { fileOnDropRejectedMessage } from '@user/utils/AttachmentRejectMessage'
import { ServiceConfig } from '@user/store/services/config'
import { getAuthHeader } from '@user/store/services/crud'
import { IDocumentModel } from '@user/store/locationDocuments'

export async function downloadDocument(doc: IDocumentModel) {
  const { documentId: id, fileName } = doc

  const authHeader = getAuthHeader()
  const url = `${ServiceConfig.baseAPIUrl}/location/core/document/${id}`

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...authHeader,
    },
    credentials: 'include',
  })

  if (response.ok) {
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    a.remove()
  }
}

export function onDropRejected(fileRejections: FileRejection[]) {
  toast.error(fileOnDropRejectedMessage(fileRejections[0].errors[0]), true)
}
